import React from "react"
import { Col, Container, Nav, NavItem, Row } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { t } from "i18next"
import { NavLink, Outlet } from "react-router-dom"
import CanView from "components/Common/CanView"

function SettingPage() {
  document.title = "Settings | Pixamo"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={t("Home")} breadcrumbItem={t("setting")} />
          <Row>
            <Col md="3">
              <Nav pills className="flex-column">
                <CanView allowedUsers={["admin"]}>
                  <NavItem>
                    <NavLink
                      to=""
                      end
                      style={{ cursor: "pointer" }}
                      className={"mb-2 card box-center nav-link"}
                    >
                      <i className="bx bx-check-shield display-5"></i>
                      <p className="h5 mb-0">{t("allowed ip")}</p>
                    </NavLink>
                  </NavItem>
                </CanView>
                <NavItem>
                  <NavLink
                    to="templates"
                    style={{ cursor: "pointer" }}
                    className={"mb-2 card box-center nav-link"}
                  >
                    <i className="bx bx-file display-5"></i>
                    <p className="h5 mb-0">{t("folder templates")}</p>
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md="9">
              <Outlet />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SettingPage
